<app-top-bar-navigation [showBackButton]="true" [title]="title" [showSkipLabel]="true" (backBtnClicked)="back()" (skipLabelClicked)="skip()"/>
<div class="px-24 py-32">
  <app-invite-sleeper [sleeper]="sleeperData" (sendInvitation)="sendInvitation($event)"/>
</div>
